import React, { useState } from 'react';
import { ScanSearch, Zap, CalendarRange, History } from 'lucide-react';
import DeviceSelector from './components/DeviceSelector';
import AnomalyDetectionTab from './AnomalyDetectionTab';
import MonthComparisonTab from './MonthComparisonTab';
import YearComparisonTab from './YearComparisonTab';

const TABS = [
    {
        id: 'anomaly',
        name: 'Резкие изменения',
        icon: Zap,
        description: 'Поиск аномальных скачков за 30 дней',
        color: 'red',
    },
    {
        id: 'month',
        name: 'Месяц к месяцу',
        icon: CalendarRange,
        description: 'Сравнение текущего и прошлого месяца',
        color: 'blue',
    },
    {
        id: 'year',
        name: 'Год к году',
        icon: History,
        description: 'Сравнение с аналогичным периодом прошлого года',
        color: 'purple',
    },
];

const COLOR_MAP = {
    red: {
        active: 'bg-red-600 text-white',
        inactive: 'bg-slate-700 text-slate-300 hover:bg-slate-600',
    },
    blue: {
        active: 'bg-blue-600 text-white',
        inactive: 'bg-slate-700 text-slate-300 hover:bg-slate-600',
    },
    purple: {
        active: 'bg-purple-600 text-white',
        inactive: 'bg-slate-700 text-slate-300 hover:bg-slate-600',
    },
};

const AnalysisPage = () => {
    const [activeTab, setActiveTab] = useState('anomaly');
    const [selectedDevice, setSelectedDevice] = useState(() => {
        const saved = localStorage.getItem('analysisSelectedDevice');
        if (saved) {
            localStorage.removeItem('analysisSelectedDevice');
            try { return JSON.parse(saved); } catch { return null; }
        }
        return null;
    });

    return (
        <div className="space-y-6">
            {/* Заголовок */}
            <div className="bg-slate-800 rounded-xl p-6 border border-slate-700">
                <h1 className="text-2xl font-bold text-white flex items-center gap-3">
                    <ScanSearch className="w-7 h-7 text-cyan-400" />
                    Сравнительный анализ
                </h1>
                <p className="text-slate-400 mt-2 text-sm">
                    Поиск аномальных показаний для приборов Аксиома-01, Аксиома-03 и Карат-307.
                    Анализ суточных архивов за 30 дней.
                </p>
            </div>

            {/* ✅ Общий DeviceSelector — виден на ВСЕХ вкладках */}
            <DeviceSelector
                selectedDevice={selectedDevice}
                onSelect={setSelectedDevice}
            />

            {/* Вкладки */}
            <div className="flex flex-wrap gap-2">
                {TABS.map(tab => {
                    const Icon = tab.icon;
                    const colors = COLOR_MAP[tab.color];
                    const isActive = activeTab === tab.id;
                    return (
                        <button
                            key={tab.id}
                            onClick={() => setActiveTab(tab.id)}
                            className={`px-5 py-3 rounded-xl text-sm font-medium transition flex items-center gap-3 border ${isActive
                                    ? `${colors.active} border-transparent shadow-lg`
                                    : `${colors.inactive} border-slate-600`
                                }`}
                        >
                            <Icon className="w-5 h-5" />
                            <div className="text-left">
                                <div>{tab.name}</div>
                                <div className={`text-xs font-normal ${isActive ? 'text-white/70' : 'text-slate-500'}`}>
                                    {tab.description}
                                </div>
                            </div>
                        </button>
                    );
                })}
            </div>

            {/* ✅ Передаём selectedDevice во ВСЕ вкладки */}
            <div>
                {activeTab === 'anomaly' && <AnomalyDetectionTab selectedDevice={selectedDevice} />}
                {activeTab === 'month' && <MonthComparisonTab selectedDevice={selectedDevice} />}
                {activeTab === 'year' && <YearComparisonTab selectedDevice={selectedDevice} />}
            </div>
        </div>
    );
};

export default AnalysisPage;